// extracted by mini-css-extract-plugin
export default {"submittingIcon":"yAftE___SubmitButton-module__submittingIcon","icon":"_30cce___SubmitButton-module__icon"};